import React, { memo } from 'react';
export function PrivateEvents() {
  return <section id="events" className="py-24 bg-white" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-74">
          {/* Left Photo */}
          <div className="order-2 lg:order-1 relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3] lg:aspect-auto lg:h-full min-h-[400px]" data-id="element-75">
            <img src="https://cdn.magicpatterns.com/uploads/p4J4ttFbKqSvGkT5687DPz/66e257274c9afe6bff35ee34_Gathering_Space-p-2000.jpg" alt="Market on 8th gathering space — private events" className="absolute inset-0 w-full h-full object-cover" data-id="element-76" />
          </div>

          {/* Right Content */}
          <div className="order-1 lg:order-2" data-id="element-77">
            <span className="inline-block font-display font-bold text-brand-orange tracking-widest uppercase text-sm mb-3" data-id="element-78">
              Celebrate With Us
            </span>
            <h2 className="font-display font-extrabold text-brand-dark text-4xl md:text-5xl mb-8 uppercase" data-id="element-79">
              Host Your Private Gathering
            </h2>

            {/* Capacity Display */}
            <div className="flex items-center gap-6 mb-8 bg-brand-cream/50 p-6 rounded-xl border border-brand-cream" data-id="element-80">
              <div className="flex items-center gap-4" data-id="element-81">
                <div className="font-display font-extrabold text-6xl md:text-7xl text-brand-orange" data-id="element-82">
                  60
                </div>
                <div className="font-display font-bold text-sm uppercase tracking-wider text-brand-dark leading-tight" data-id="element-83">
                  Indoor
                  <br data-id="element-84" />
                  Seats
                </div>
              </div>

              <div className="w-px h-16 bg-brand-dark/10" data-id="element-85"></div>

              <div className="flex items-center gap-4" data-id="element-86">
                <div className="font-display font-extrabold text-6xl md:text-7xl text-brand-orange" data-id="element-87">
                  80
                </div>
                <div className="font-display font-bold text-sm uppercase tracking-wider text-brand-dark leading-tight" data-id="element-88">
                  Outdoor
                  <br data-id="element-89" />
                  Patio
                </div>
              </div>
            </div>

            <p className="text-brand-dark/80 text-base leading-relaxed mb-4" data-id="element-90">
              Whether you're celebrating a special occasion, hosting a business
              meeting, or gathering with family and friends, our venue is the
              perfect setting.
            </p>
            <p className="text-brand-dark/80 text-base leading-relaxed mb-10" data-id="element-91">
              We offer cozy indoor seating for up to 60 guests, along with a
              spacious outdoor patio that accommodates 80 people. Let us help
              you create unforgettable memories with a culinary diversity not
              found anywhere else in San Diego.
            </p>

            <a href="mailto:info@marketon8th.com" className="inline-flex items-center justify-center bg-brand-orange hover:bg-brand-coral text-white px-8 py-4 rounded-none font-bold transition-all transform hover:scale-105 shadow-md uppercase tracking-wider text-sm" data-id="element-92">
              Inquire About Your Event
            </a>
          </div>
        </div>
      </div>
    </section>;
}